import React, { Fragment, useEffect, useState } from 'react';
import { CardBody, Card, CardTitle } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';

const BarChart = ({ options, title, height = 250, colors = ['#02a499'] }) => {
  const [series, setSeries] = useState([]);
  const [label, setLabel] = useState([]);

  useEffect(() => {
    let seriesArray = [];
    let labelArray = [];
    options.forEach((element) => {
      seriesArray.push(element.value);
      labelArray.push(element.name);
    });
    setSeries(seriesArray);
    setLabel(labelArray);
  }, [options]);

  const data = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: colors,
    grid: {
      borderColor: '#f1f1f1',
    },
    xaxis: {
      categories: label,
      labels: {
        formatter: function (value) {
          return value;
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value;
        },
      },
    },
  };

  return (
    <Fragment>
      {console.log('barchart', series)}
      <ReactApexChart
        options={data}
        series={[{ name: 'Jumlah Pegawai', data: series }]}
        type="bar"
        height={height}
      />
    </Fragment>
  );
};

export default BarChart;
